// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd8c3eb2","455":"011f11bb"}[chunkId] + ".chunk.js";
};